import React from 'react'

function Registration()
{
  
    return(
        
        <div >
         
             <h2 class="d-flex justify-content-center">Register Your Team  Now...!</h2>
             <div class="d-flex justify-content-center" style={{width:700,height:340,margin: 'auto',background:'#000000'}}>
             <img className="block w-100 h-100"
          src="https://res.cloudinary.com/dxr8nm7g8/image/upload/v1667141310/WhatsApp_Image_2022-10-30_at_3.35.25_PM_vyjqc9.jpg"
          alt="Second slide"
        />
</div>
<div class="d-flex justify-content-center" style={{ paddingTop: 12}}>
              <a  class="btn btn-primary" href="https://docs.google.com/forms/d/e/1FAIpQLSd7eT4aCMa33W_frPubWUAbyz_pOESdWzyDvUCSBOpBYlz2Ug/closedform"
        target="blank" >Click Here to Register</a>
        </div>
        </div>
       )
}

export default Registration;